import contact from './contact';

export default `

    <div class="container">
        <div class="row align-items-center mt-2 mt-lg-5">
            <div class="col-lg-6">
                <div class="banner-content">
                    <h1>Madras ironing company</h1>
                    <p>Does ironing your clothes make your weekends stressful? How does it sound if we say, we would do that errand for you? Yes we are for real and we provide the service that reduces your to-do list. We are the Madras Ironing company, who pickup and deliver your freshly ironed clothes for free. We don’t have any minimum orders, even if you want your one favourite shirt to be ironed, we will do it for you. We provide both normal and steam ironing. Aren’t these enough good reasons to try us out? wrinkle-free clothes can be stress-free from now on.</p>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="banner-image">
                    <img alt="ironed-Cloth" src="./assets/img/cloth.png" />
                </div>
            </div>
        </div>
    <div>
`